/**
 * Loads predictive-search.js (and ensures CSS is applied) on first search use.
 */
(function () {
  if (window.__predictiveSearchLoaderInit) return;
  window.__predictiveSearchLoaderInit = true;

  var config = window.__deferredPredictiveSearch;
  if (!config || !config.script) return;

  var promise;

  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-deferred-predictive-search]');
      if (existing) {
        if (existing.dataset.loaded === 'true') resolve();
        else existing.addEventListener('load', resolve, { once: true });
        return;
      }
      var script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.dataset.deferredPredictiveSearch = 'true';
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve();
      }, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  function ensureCss() {
    if (!config.css) return;
    var link = document.querySelector('link[data-deferred-predictive-search-css]');
    if (link) {
      if (link.media !== 'all') link.media = 'all';
      return;
    }
    link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = config.css;
    link.media = 'all';
    link.dataset.deferredPredictiveSearchCss = 'true';
    document.head.appendChild(link);
  }

  window.ensurePredictiveSearch = function ensurePredictiveSearch() {
    if (!promise) {
      ensureCss();
      promise = loadScript(config.script);
    }
    return promise;
  };

  function shouldLoad(event) {
    var target = event.target;
    if (!target || !target.closest) return false;
    return !!(
      target.closest('predictive-search') ||
      target.closest('details-modal') ||
      target.closest('.header__search') ||
      target.closest('.search-modal') ||
      target.closest('.header__icon--search') ||
      target.closest('[aria-controls="SearchModal"]')
    );
  }

  function prefetch() {
    window.ensurePredictiveSearch();
  }

  document.addEventListener('focusin', function (event) {
    if (shouldLoad(event)) prefetch();
  }, true);

  document.addEventListener('pointerdown', function (event) {
    if (shouldLoad(event)) prefetch();
  }, true);
})();
